module.exports = __webpack_public_path__ + "img/image.ac0fd7c8.svg";